import Vue from 'vue'
import VueRouter from 'vue-router'
import TrackerPage from '../components/pages/Tracker'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: TrackerPage
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
